import { Card } from '@nextui-org/react';
import Image from 'next/image';
import Link from 'next/link';
import { Suspense } from 'react';
import 'react-loading-skeleton/dist/skeleton.css';

import styled from '@emotion/styled';
import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';

export function BlurringImage({
  svg: [Svg, svgProps, rectangles],
  img,
  alt,
  style,
  blurLevel = 5,
  height,
  width,
  ...props
}: {
  svg: any;
  img: any;
  alt?: string;
  style?: any;
  blurLevel?: number;
  height?: number;
  width?: number;
  props?: any;
}) {
  const [hasPlaceholder, setHasPlaceholder] = useState(true);

  return (
    <Container className="m-auto ml-2 rounded-md" style={style}>
      {hasPlaceholder && (
        <Svg
          {...svgProps}
          style={{
            ...svgProps.style,
            filter: `blur(${blurLevel}px)`,
          }}
        >
          {rectangles.map(([Rect, rectProps]: any) => (
            <Rect {...rectProps} key={`${rectProps.x}${rectProps.y}`} />
          ))}
        </Svg>
      )}

      <Suspense fallback={<Skeleton height={100} width={100} />}>
        <Image
          alt={alt || 'book'}
          className="h-auto w-auto"
          height={100}
          src={img?.src}
          // fill
          // objectFit="contain"
          // {...props}
          width={100}
          onLoadingComplete={() => setHasPlaceholder(false)}
        />
      </Suspense>
    </Container>
  );
}

const Container = styled.div`
  position: relative;
  overflow: hidden;
  height: 140px;
`;

export default function BookCard({
  name,
  author,
  id,
  englishName,
}: {
  name?: string | null;
  author: string;
  id: string;
  englishName?: string | null;
}) {
  const [coverLoading, setCoverLoading] = useState(true);

  return (
    <Link className="justify-center md:w-full w-full md:m-2" href={`/book/${id}`} scroll={false}>
      <div className="flex">
        <Card isHoverable isPressable className="justify-center h-40 md:m-4 m-2 text-center">
          <div className="flex flex-row ">
            {/* {coverLoading && (
              <Skeleton
                inline
                className="w-full h-36 leading-none m-2"
                count={1}
                // height={100}
                width={100}
              />
            )} */}
            <Image
              alt={`book cover for ${name} (${englishName}) by ${author}`}
              className="rounded-md m-2"
              height={144}
              src={`/css/images/${id}.jpeg`}
              width={100}
              onLoadingComplete={() => setCoverLoading(false)}
            />
            {/* <BlurringImage img={img} svg={svg} /> */}
            <div className="w-full my-auto px-2">
              {/* <Skeleton className="rounded-md w-full h-full" count={1} height={100} /> */}
              <div className="font-bold sm:text-2xl text-xl text-center">{name}</div>
              <p className="sm:text-base text-sm">{englishName}</p>
              <p className="font-semibold sm:text-base text-sm">{author.split('(')[0]}</p>
              <p>
                {author.split('(')[1] && '('}
                {author.split('(')[1]}
              </p>
            </div>
          </div>
        </Card>
      </div>
    </Link>
  );
}
